import initialState from './initialState';
import * as types from '../actions/stateWarningsActions/actionTypes';

export default function stateWarningsReducer(state = initialState.stateWarnings, action) {
  switch (action.type) {
    case types.SET_STATE_WARNINGS:
      return {
        ...state,
        items: action.items
      };

    case 'CANCEL_OPERATION':
      return initialState.stateWarnings;

    default:
      return state;
  }
}